export const state = {
  apiError: false,
  loadingRequest: false,
  notification: {
    message: null,
    mode: 'success'
  },
  uploadProgress: false,

  clientAuth: {},
  currentClient: null,
  clientLoaded: false,

  userAuth: {},
  currentUser: null,
  userLoaded: false,

  counts: {},
  productRegistrations: [],
  prFormInfos: {},
  reviews: {},

  documents: [],
  interventions: {},
  trainings: {}
}
